import React from 'react';
import LegalFooter from '../components/LegalFooter';
import './PrivacyPolicyPage.css';

const PrivacyPolicyPage = () => {
  const lastUpdated = 'April 12, 2026';

  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <header className="privacy-header">
          <h1>Privacy Policy</h1>
          <p>Last updated: {lastUpdated}</p>
        </header>

        <section>
          <h2>1. Introduction</h2>
          <p>
            Reelo ("we", "our", "us") is a creator growth platform where users join competitions,
            submit video links, and grow their audience. This Privacy Policy explains what
            information we collect, how we use it, and what choices you have.
          </p>
        </section>

        <section>
          <h2>2. Information We Collect</h2>
          <ul>
            <li>Account details such as your name, email address, and profile photo.</li>
            <li>
              Sign-in details when you use email/password or Google Sign-In (basic profile
              information only).
            </li>
            <li>
              Competition and submission data, including video links, captions, and related content
              you choose to submit.
            </li>
            <li>Usage and device information used for performance, fraud prevention, and security.</li>
          </ul>
        </section>

        <section>
          <h2>3. Google Sign-In and Authentication</h2>
          <p>
            If you sign in with Google, we may receive your name, email address, and profile
            picture from your Google account. We use this data only for account creation,
            authentication, and profile display. We do not request unnecessary access to your
            private Google data.
          </p>
        </section>

        <section>
          <h2>4. User-Generated Content and Submissions</h2>
          <p>
            Reelo allows users to submit video links and related content to competitions. You are
            responsible for the content you submit and must have the rights or permission to share
            it.
          </p>
          <p>
            By submitting content, you allow Reelo to host, display, feature, and promote that
            submission within the platform and related competition experiences.
          </p>
        </section>

        <section>
          <h2>5. Public Visibility During Competitions</h2>
          <p>
            Competitions are community-facing. Your submitted video links, display name, profile
            image, and competition performance details may be visible to other users based on the
            competition format.
          </p>
        </section>

        <section>
          <h2>6. How We Use Information</h2>
          <ul>
            <li>To provide core platform functionality and user accounts.</li>
            <li>To run competitions, ranking, and creator participation features.</li>
            <li>To improve product quality, safety, and user experience.</li>
            <li>To communicate important updates and support responses.</li>
          </ul>
        </section>

        <section>
          <h2>7. Third-Party Services</h2>
          <p>
            Reelo may integrate with third-party services such as YouTube and Google login.
            When you interact with those services, their own privacy policies apply. Reelo is not
            responsible for the privacy or data practices of third-party platforms.
          </p>
        </section>

        <section>
          <h2>8. Sharing and Disclosure</h2>
          <p>
            We do not sell personal information. We may share data with trusted service providers
            needed to operate the platform (for example hosting, analytics, and authentication).
            We may also disclose information when required by law or to protect platform security
            and users.
          </p>
        </section>

        <section>
          <h2>9. Data Security</h2>
          <p>
            We use reasonable technical and organizational safeguards to protect your data,
            including secure transport practices, access controls, and monitoring to reduce misuse
            or unauthorized access. No system is 100% secure, so we also recommend strong
            passwords and safe account practices.
          </p>
        </section>

        <section>
          <h2>10. Data Retention</h2>
          <p>
            We retain information as long as needed to provide services, comply with legal
            obligations, resolve disputes, and enforce agreements.
          </p>
        </section>

        <section>
          <h2>11. Children's Privacy</h2>
          <p>
            Reelo is not intended for children under 13 years of age. We do not knowingly collect
            personal information from children under 13.
          </p>
        </section>

        <section>
          <h2>12. Legal Compliance and Jurisdiction</h2>
          <p>
            We process and protect data in accordance with applicable laws. For users in India,
            this includes relevant Indian legal requirements. Depending on where you access Reelo,
            local laws may also apply.
          </p>
        </section>

        <section>
          <h2>13. Your Choices</h2>
          <ul>
            <li>You can update account information in your profile settings.</li>
            <li>You can request account deletion or data access through support.</li>
            <li>You can stop using the platform at any time.</li>
          </ul>
        </section>

        <section>
          <h2>14. Contact</h2>
          <p>
            For privacy questions, contact us at <a href="mailto:privacy@reelo.co.in">privacy@reelo.co.in</a>.
          </p>
        </section>

        <footer className="privacy-footer">
          <LegalFooter showBackToLogin />
        </footer>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
